import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Navigation from '../../Components/Navigation'
import { Lock } from 'react-bootstrap-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import './misListas.css'
import { useDispatch, useSelector } from 'react-redux'
import {
  emptyCart,
  priceListAddToCart,
} from '../../redux/actions/cartActions.js'
import {
  addToList,
  clearList,
  removeFromList,
} from '../../redux/actions/listActions'
import MiniLoading from '../../Components/MiniLoading'
import Search from '../../Assets/Images/Departamentos/search.png'
import ListProduct from '../../Components/ListProduct'
import ProductSearch from '../../Components/ProductSearch'
import NoImage from '../../Assets/Images/Logos/no-image.png'
import Modal from 'react-bootstrap/Modal'
import RemoveProduct from '../../Components/ProductList/RemoveProduct'
import { t } from 'i18next'
import {
  createQuickListAction,
  getProductsByQuickListIdAction,
  getQuickListsWithoutDetailAction,
} from 'redux/actions/quickListsActions'
import { ROUTES } from 'Utils/constants'
import { fetchPriceInventory } from 'redux/actions/priceProductsAction'
import { getFragmentedService } from 'Utils/Helpers/getFragmentedService'
import { useDebounce } from 'Hooks/useDebounce'

const PRODUCT_CUSTOM_LIST_TYPE = {
  MIS_LISTAS: '2581263E-0FC7-4731-A4D1-6D769A482940',
  LISTAS_RAPIDAS: '8277F210-DAA8-11EC-9D64-0242AC120002',
}

function MisListas() {
  const debounce = useDebounce()
  const stateListDetails = 0
  const stateNewList = 1
  const stateEditList = 2
  const [selected, setSelected] = useState('')
  const productsRef = useRef(null)
  const listContainer = useRef(null)
  const [lists, setLists] = useState([])
  const [containerLoader, setContainerLoader] = useState(true)
  const [loading, setLoading] = useState(true)
  const [loadingList, setLoadingList] = useState(true)
  const [selectedList, setSelectedList] = useState({})
  const [products, setProducts] = useState([])
  const [search, setSearch] = useState([])
  const [searchPrices, setSearchPrices] = useState([])
  const [misListasLength, setMisListasLength] = useState(0)
  const [listasRapidasLength, setListasRapidasLength] = useState(0)
  const [viewState, setViewState] = useState(stateListDetails)
  const [newListName, setNewListName] = useState('')
  const [selectAll, setSelectAll] = useState(false)
  const history = useHistory()
  const [editingListObject, setEditingListObject] = useState({})
  const [showModalRemoveProduct, setShowModalRemoveProduct] = useState(false)
  const [confirmRemoveProduct, setConfirmRemoveProduct] = useState(false)
  const [productToRemove, setProductToRemove] = useState({})

  const [textSearch, setTextSearch] = useState('')

  // STATE OF CHECKS
  const [checkedState, setCheckedState] = useState(null)

  // TRACKS THE MOST RECENT PRODUCTS REQUEST SO STALE RESPONSES ARE IGNORED
  const productsRequestIdRef = useRef(0)
  // TRACKS THE MOST RECENT PRICES REQUEST SO STALE RESPONSES ARE IGNORED
  const pricesRequestIdRef = useRef(0)
  // RESOLVES ONCE ProductSearch HAS MOUNTED AND CLEARED THE CURRENT LIST
  const listClearedResolverRef = useRef(null)

  const dispatch = useDispatch()

  // REDUX
  const UserId = useSelector(
    state => state.login?.user?.CustomerInfo?.CustomerId
  )
  const WarehouseId = useSelector(state => state?.company?.WarehouseId)
  const currentList = useSelector(state => state.list.list)
  const currentCart = useSelector(state => state.cart.cart)

  // SOLICITAR LAS LISTAS
  const getAllLists = async () => {
    setLoadingList(true)

    const payload = {
      Status: true,
      UserId,
      WarehouseId,
      PageSize: 1000,
      PageNumber: 1,
    }
    try {
      const response = await dispatch(getQuickListsWithoutDetailAction(payload))
      if (selected) {
        const list = response.data.Data.filter(list => {
          return list.ProductCustomListTypeId === selected
        })

        const filteredLists = list[0]?.ListDetailProductCustomList ?? []
        setLists(filteredLists)
        setSelectedList(filteredLists[0] ?? {}) // SELECT THE FIRST AS DEFAULT
      } else {
        const generalData = response.data.Data.map(list => {
          return list.ListDetailProductCustomList
        }).flat()

        setMisListasLength(
          checkLength(generalData, PRODUCT_CUSTOM_LIST_TYPE.MIS_LISTAS)
        )
        setListasRapidasLength(
          checkLength(generalData, PRODUCT_CUSTOM_LIST_TYPE.LISTAS_RAPIDAS)
        )
        setLists(generalData)
        setSelectedList(generalData[0]) // SELECT THE FIRST AS DEFAULT
      }
    } catch (error) {
      console.error('Error getting quick lists:', error)
      setLists([])
      setLoadingList(false)
    }
  }

  // CHECK LIST LENGTH
  const checkLength = (array, value) => {
    return array.filter(element => {
      return element.ProductCustomListTypeId === value
    }).length
  }

  // CAMBIO DE TIPO LISTA
  const handleChange = e => {
    setTextSearch('')
    setSelected(e.target.value)
  }

  // CAMBIO DE LISTA
  const handleList = (e, list) => {
    if (
      selectedList?.ProductCustomListId === list.ProductCustomListId &&
      viewState === stateListDetails
    ) {
      return
    }

    setTextSearch('')
    setCheckedState([])
    setSelectAll(false)
    if (currentCart.length > 0) {
      dispatch(emptyCart())
    }
    setViewState(stateListDetails)
    setSelectedList(list)
  }

  const searchProductsByQuickList = useCallback(
    async (list = null) => {
      if (!list && !selectedList) return []
      const customList = list || selectedList
      const requestId = ++productsRequestIdRef.current
      const payload = {
        Status: true,
        UserId,
        WarehouseId,
        ProductCustomListId: customList.ProductCustomListId,
      }
      let products = []
      try {
        const response = await dispatch(getProductsByQuickListIdAction(payload))
        // A NEWER REQUEST WAS ISSUED WHILE THIS ONE WAS IN FLIGHT: DROP IT
        if (requestId !== productsRequestIdRef.current) return []

        const matchedList = response.data.Data.find(
          group =>
            group.ProductCustomListTypeId === customList.ProductCustomListTypeId
        )
        // The response only retrieves one detail: ListDetailProductCustomList
        // items don't carry a ProductCustomListId to match against, so the
        // single entry returned here can't be looked up by id.
        products =
          matchedList?.ListDetailProductCustomList?.[0]?.ProductList ?? []
      } catch (error) {
        console.error('Error loading quick list products:', error)
        if (requestId === productsRequestIdRef.current) {
          setProducts([])
          setSearch([])
          setLoading(false)
        }
        throw error
      }
      setProducts(products)
      setSearch(products)
      return products
    },
    [UserId, WarehouseId, dispatch, selectedList]
  )

  // HANDLE SEARCH
  const handleSearch = e => {
    setTextSearch(e.target.value)
    debounce(() => {
      if (e.target.value.length > 0) {
        const newSearch = products.filter(product => {
          return (
            product?.ProductName?.toLowerCase()?.includes(
              e.target.value.toLowerCase()
            ) ||
            product?.ShortDescription?.toLowerCase()?.includes(
              e.target.value.toLowerCase()
            ) ||
            product?.SystemCode?.toLowerCase()?.includes(
              e.target.value.toLowerCase()
            )
          )
        })
        setSearch(newSearch)
      } else {
        setSearch(products)
      }
    }, 500)
  }

  // HANDLE SELECT ALL
  const handleSelectAll = (e, products) => {
    setSelectAll(e.target.checked)
    const updatedCheckedState = products.map(product =>
      Number(product?.Price) > 0 ? e.target.checked : false
    )
    setCheckedState(updatedCheckedState)
  }

  const handleCreateQuotation = async () => {
    const selectedProducts = searchPrices.filter(
      (_, index) => checkedState?.[index]
    )

    if (selectedProducts.length < 1) return

    dispatch(emptyCart())
    const productsAdded = await dispatch(priceListAddToCart(selectedProducts))

    if (productsAdded) {
      history.push({
        pathname: ROUTES.createQuote,
        state: { from: 'Mis Listas' },
      })
    }
  }

  const createNewList = async () => {
    const arrayOfIds = currentList.map(product => product.ProductId)
    const payload = {
      Name: newListName,
      ProductCustomListId: null,
      Warehouses: WarehouseId,
      Description: 'Prueba de Creación de una lista de Mis Listas',
      ProductCustomListTypeId: PRODUCT_CUSTOM_LIST_TYPE.MIS_LISTAS,
      UserId,
      Products: arrayOfIds,
      Status: true,
    }
    try {
      await dispatch(createQuickListAction(payload))
      setViewState(stateListDetails)
    } catch (error) {
      console.error('Error creating quick list:', error)
      return
    }
    getAllLists()
    dispatch(clearList())
  }

  const getPrices = async PriceInventoryPayload => {
    setLoading(true)
    const requestId = ++pricesRequestIdRef.current
    try {
      const response = await getFragmentedService({
        service: payload => dispatch(fetchPriceInventory(payload)),
        payload: PriceInventoryPayload,
      })
      // A NEWER PRICES REQUEST WAS ISSUED WHILE THIS ONE WAS IN FLIGHT: DROP IT
      if (requestId !== pricesRequestIdRef.current) return response
      const updatedSearch = search.map(item => {
        const priceItem = response.find(
          product => product.ProductId === item.ProductId
        )
        return {
          ...item,
          ...priceItem,
        }
      })
      setSearchPrices(updatedSearch)
      setLoading(false)
      setLoadingList(false)
      return response
    } catch (error) {
      if (requestId === pricesRequestIdRef.current) {
        setLoading(false)
      }
      throw error
    }
  }

  useEffect(() => {
    if (search?.length) {
      const productIds = search.map(item => item.ProductId)
      getPrices(productIds)
    } else {
      // INVALIDATE ANY IN-FLIGHT PRICES REQUEST SO IT CAN'T REPOPULATE
      // searchPrices AFTER WE'VE JUST CLEARED IT
      pricesRequestIdRef.current += 1
      setLoading(false)
      setLoadingList(false)
      setSearchPrices([])
    }
  }, [search])

  useEffect(() => {
    if (containerLoader && productsRef && productsRef.current)
      setContainerLoader(false)
  }, [productsRef])

  useEffect(() => {
    getAllLists()
    dispatch(emptyCart())
  }, [selected])

  useEffect(() => {
    if (products && products.length > 0) {
      setCheckedState(new Array(products.length).fill(false))
      setSelectAll(false)
    }
  }, [products])

  useEffect(() => {
    if (!selectedList?.ProductCustomListId) return

    const loadListProducts = async () => {
      try {
        await searchProductsByQuickList()
      } catch (error) {
        console.error('Error loading selected list products:', error)
      }
    }
    loadListProducts()
  }, [selectedList, searchProductsByQuickList])

  // WAITS FOR ProductSearch TO MOUNT AND CLEAR THE CURRENT LIST BEFORE
  // PRODUCTS ARE ADDED, INSTEAD OF GUESSING WITH A FIXED DELAY
  const waitForListCleared = () =>
    new Promise(resolve => {
      listClearedResolverRef.current = resolve
    })

  const handleListCleared = () => {
    listClearedResolverRef.current?.()
    listClearedResolverRef.current = null
  }

  // START EDIT LIST PROCESS
  const handleEditList = async (e, list) => {
    e.stopPropagation()

    setViewState(stateEditList)
    dispatch(clearList())

    if (currentCart.length > 0) {
      dispatch(emptyCart())
    }

    if (list.ProductCustomListId) {
      try {
        const listCleared = waitForListCleared()
        const listProducts = await searchProductsByQuickList(list)
        await listCleared
        listProducts.forEach(product => dispatch(addToList(product)))
      } catch (error) {
        console.error('Error loading products to edit list:', error)
      }
    }

    setEditingListObject(list)
  }

  const removeProductEditList = product => {
    setProductToRemove(product)
    handleModalRemoveProduct()
  }

  const saveEditList = async () => {
    const arrayOfIds = currentList.map(product => product.ProductId)

    const payload = {
      Name: editingListObject.Name,
      ProductCustomListId: editingListObject.ProductCustomListId,
      Warehouses: null,
      Description: editingListObject.Description,
      ProductCustomListTypeId: editingListObject.ProductCustomListTypeId,
      UserId: editingListObject.UserId,
      Products: arrayOfIds,
      Status: true,
    }
    try {
      await dispatch(createQuickListAction(payload))
      setViewState(stateListDetails)
    } catch (error) {
      console.error('Error saving quick list:', error)
      return
    }
    getAllLists()
    dispatch(clearList())
  }

  const getMenuName = () => {
    return viewState === stateEditList && editingListObject != null
      ? editingListObject.Name
      : t('MY_LISTS_T.LIST_DEFAULT_TITLE')
  }

  const handleModalRemoveProduct = () => {
    setShowModalRemoveProduct(!showModalRemoveProduct)
  }

  useEffect(() => {
    if (confirmRemoveProduct) {
      dispatch(removeFromList(productToRemove))
      setConfirmRemoveProduct(false)
    }
  }, [confirmRemoveProduct])

  return (
    <>
      <Navigation />
      <div className="my_list_body" data-testid="container-my-list-body">
        <Row className="lists_container">
          <Col xs={3} className="my_lists">
            <div
              className="my_lists_container"
              data-testid="container-my-lists">
              <h2>{getMenuName()}</h2>
              {viewState === stateListDetails && (
                <div
                  className="list_creation"
                  onClick={() => {
                    // setOpenInputNewList(!openInputNewList)
                    dispatch(clearList())
                    setViewState(stateNewList)
                  }}
                  data-testid="btn-create-list">
                  <label className="add_list_text" htmlFor="add_list">
                    {t('MY_LISTS_T.CREATE_LIST_LABEL')}{' '}
                  </label>
                  <div id="add_list" className="add_list">
                    +
                  </div>
                </div>
              )}
              {viewState === stateNewList && (
                <div className="add_list_input">
                  <input
                    onChange={e => {
                      setNewListName(e.target.value)
                    }}
                    type="text"
                    className="add_list_create"
                    name="add_list_create"
                    placeholder={t('MY_LISTS_T.ADD_NAME_PLACEHOLDER')}
                    data-testid="input-list-name-create"
                  />
                  <div className="add_list_buttons">
                    <button
                      className="add_list_cancelar"
                      onClick={() => {
                        setViewState(stateListDetails)
                        dispatch(clearList())
                      }}
                      data-testid="btn-cancel-create-list">
                      {t('MY_LISTS_T.CANCEL_BUTTON')}{' '}
                    </button>
                    <button
                      className="add_list_continuar"
                      disabled={currentList < 1 || newListName.length < 1}
                      onClick={createNewList}
                      data-testid="btn-continue-create-list">
                      {t('MY_LISTS_T.CONTINUE_BUTTON')}{' '}
                    </button>
                  </div>
                </div>
              )}
              {viewState === stateEditList && (
                <>
                  <div className="add_list_buttons">
                    <button
                      className="add_list_cancelar"
                      onClick={() => {
                        setViewState(stateListDetails)
                        setEditingListObject(null)
                      }}
                      data-testid="btn-cancel-edit-list">
                      {t('MY_LISTS_T.CANCEL_BUTTON')}{' '}
                    </button>
                    <button
                      className="add_list_continuar"
                      onClick={saveEditList}
                      data-testid="btn-save-edit-list">
                      {t('MY_LISTS_T.SAVE_BUTTON')}{' '}
                    </button>
                  </div>

                  <ul className="my-new-list-products">
                    {currentList.map(product => {
                      return (
                        <li
                          key={product.ProductId}
                          className="product-edit-list">
                          <div className="product-edit-list-img">
                            <img
                              src={
                                product?.Images
                                  ? product?.Images[0]?.URL
                                  : product?.URL || NoImage
                              }
                              className="img-fluid"
                              alt="product"
                            />
                          </div>
                          <div className="product-edit-list-text">
                            <h3>{product?.ProductName}</h3>
                            <p>{product?.BrandName}</p>
                            <p>{product?.Sku}</p>
                          </div>
                          <div className="product-edit-list-trash">
                            <FontAwesomeIcon
                              style={{ fontSize: '1.5rem' }}
                              icon={faTrashCan}
                              onClick={() => {
                                removeProductEditList(product)
                              }}
                            />
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                </>
              )}
              {viewState === stateNewList && (
                <ul className="my-new-list-products">
                  {currentList.map(product => {
                    return (
                      <li key={product.ProductId} className="product-from-list">
                        <div className="product-from-list-img">
                          <img
                            src={
                              product?.Images
                                ? product?.Images[0]?.URL
                                : product?.URL || NoImage
                            }
                            className="img-fluid"
                            alt="product"
                          />
                        </div>
                        <div className="product-from-list-text">
                          <h3>{product?.ProductName}</h3>
                          <p>{product?.Brand}</p>
                          <p>{product?.Sku}</p>
                        </div>
                      </li>
                    )
                  })}
                </ul>
              )}
              {viewState === stateListDetails && (
                <>
                  <div className="lists_types" data-testid="lists-types">
                    <div className="list_type">
                      <input
                        id="todo"
                        type="radio"
                        name="list_type"
                        value=""
                        onChange={handleChange}
                        checked={selected === ''}
                        data-testid="input-todo"
                      />
                      <label htmlFor="todo">{t('MY_LISTS_T.TODO_LABEL')}</label>
                    </div>
                    <div className="list_type">
                      <input
                        id="mis_listas"
                        type="radio"
                        name="list_type"
                        value={PRODUCT_CUSTOM_LIST_TYPE.MIS_LISTAS}
                        onChange={handleChange}
                        checked={
                          selected === PRODUCT_CUSTOM_LIST_TYPE.MIS_LISTAS
                        }
                        disabled={!misListasLength > 0}
                        data-testid="input-my-lists"
                      />
                      <label htmlFor="mis_listas">
                        {t('MY_LISTS_T.LIST_DEFAULT_TITLE')}
                      </label>
                    </div>
                    <div className="list_type">
                      <input
                        id="listas_rapidas"
                        type="radio"
                        name="list_type"
                        value={PRODUCT_CUSTOM_LIST_TYPE.LISTAS_RAPIDAS}
                        onChange={handleChange}
                        checked={
                          selected === PRODUCT_CUSTOM_LIST_TYPE.LISTAS_RAPIDAS
                        }
                        disabled={!listasRapidasLength > 0}
                        data-testid="input-quick-lists"
                      />
                      <label htmlFor="listas_rapidas">
                        {t('MY_LISTS_T.RAPID_LISTS_LABEL')}
                      </label>
                    </div>
                  </div>
                  <ul className="user_lists" data-testid="list-types">
                    {loadingList ? (
                      <MiniLoading />
                    ) : (
                      lists.map(list => {
                        return (
                          <li
                            className={
                              selectedList.ProductCustomListId ===
                              list.ProductCustomListId
                                ? 'user_list_selected'
                                : 'user_list'
                            }
                            onClick={e => handleList(e, list)}
                            key={list.ProductCustomListId}>
                            <div className="list-name gap-3">
                              {list.ProductCustomListTypeId ===
                              PRODUCT_CUSTOM_LIST_TYPE.LISTAS_RAPIDAS ? (
                                <Lock />
                              ) : (
                                <FontAwesomeIcon
                                  style={{ color: '#25B0F8', fontSize: '2rem' }}
                                  icon={faPlusCircle}
                                  onClick={e => handleEditList(e, list)}
                                />
                              )}
                              <p>{list.Name}</p>
                            </div>
                            <div>
                              <p>{list.ProductListCount}</p>
                            </div>
                          </li>
                        )
                      })
                    )}
                  </ul>
                </>
              )}
            </div>
          </Col>
          {viewState === stateNewList || viewState === stateEditList ? (
            <Col xs={9} className="product-search">
              <ProductSearch
                productsRef={productsRef}
                inListScreen={true}
                onListCleared={handleListCleared}
              />
            </Col>
          ) : (
            <Col
              xs={9}
              className="products_list"
              ref={listContainer}
              data-testid="container-products-list">
              {loading ? (
                <MiniLoading />
              ) : (
                <div>
                  <div className="list-title">
                    <h2>{selectedList?.Name}</h2>
                  </div>
                  <div className="list-search-bar">
                    <input
                      type="text"
                      placeholder={t('MY_LISTS_T.SEARCH_PLACEHOLDER')}
                      onChange={handleSearch}
                      value={textSearch}
                      data-testid="input-search-list"
                    />
                    <img
                      src={Search}
                      alt="search-icon"
                      className="search-icon"
                    />
                  </div>
                  {searchPrices.length > 0 ? (
                    <>
                      <div className="select-all-list">
                        <label htmlFor="selectAll">
                          {t('MY_LISTS_T.SELECT_ALL_LABEL')}
                        </label>
                        <input
                          type="checkbox"
                          onChange={e => handleSelectAll(e, searchPrices)}
                          checked={selectAll}
                          id="selectAll"
                          name="selectAll"
                          data-testid="input-select-all-products"
                        />
                      </div>
                      <Row
                        xs={2}
                        sm={3}
                        md={4}
                        lg={4}
                        xl={5}
                        className="product-list-display-container">
                        {searchPrices?.map((product, index) => {
                          return (
                            <ListProduct
                              product={{
                                ...product,
                                BasePrice: product.Price,
                                FinalPrice: product.Price,
                              }}
                              checkedState={checkedState}
                              setCheckedState={setCheckedState}
                              position={index}
                              key={index}
                            />
                          )
                        })}
                      </Row>
                    </>
                  ) : (
                    <p className="empty-list">
                      Esta lista rápida no contiene productos disponibles.
                    </p>
                  )}
                </div>
              )}
              <div className="add-list-to-quote">
                <button
                  disabled={checkedState?.indexOf(true) === -1}
                  onClick={handleCreateQuotation}
                  data-testid="btn-create-quotation-from-list">
                  {t('MY_LISTS_T.CREATE_QUOTATION')}{' '}
                </button>
              </div>
            </Col>
          )}
        </Row>

        {/* Modal confirmar eliminar producto */}
        <Modal show={showModalRemoveProduct} centered>
          <RemoveProduct
            setShowModalRemoveProduct={handleModalRemoveProduct}
            setConfirmRemoveProduct={setConfirmRemoveProduct}
          />
        </Modal>
      </div>
    </>
  )
}

export default MisListas
